import React from "react";

interface IBackCards {
  setMultipleCard: ({ userId: number, status: boolean }) => void;
}

export default function BackCards({ setMultipleCard }: IBackCards) {
  return (
    <div className="btn-filter-hours-management bakc-filter-hours-management flex ">
      <button
        onClick={() => {
          setMultipleCard({ userId: 0, status: false });
        }}
        className="btn bg-primary"
      >
        VOLTAR
      </button>
    </div>
  );
}
